/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-unsafe-optional-chaining */
import useCommon from '@utils/hooks/common';
import React from 'react';
import {GameResultOnScreen} from '@interface/index';
import {GameLogicInterface} from 'poker-interfaces';
import classNames from 'classnames';
import styles from './styles';

interface ResultImageProps {
  combinationName?: GameLogicInterface.Combination;
}

const folderPath = '/images-mobile/game-room/result-render/handTypes/';

const resultImageAttributes = new Map<
  GameLogicInterface.Combination,
  {
    imagePath: string;
    alt: string;
  }
>([
  ['HI_CARD', {imagePath: folderPath.concat('hiCard').concat('.png'), alt: 'High Card'}],
  ['PAIR', {imagePath: folderPath.concat('onePair').concat('.png'), alt: 'One Pair'}],
  ['TWO_PAIRS', {imagePath: folderPath.concat('twoPairs').concat('.png'), alt: 'Two Pairs'}],
  ['THREE_OF_A_KIND', {imagePath: folderPath.concat('set').concat('.png'), alt: 'Three of a kind'}],
  ['FOUR_OF_A_KIND', {imagePath: folderPath.concat('quad').concat('.png'), alt: 'Four of a kind'}],
  ['STRAIGHT', {imagePath: folderPath.concat('straight').concat('.png'), alt: 'Straight'}],
  ['FLUSH', {imagePath: folderPath.concat('flush').concat('.png'), alt: 'Flush'}],
  [
    'STRAIGHT_FLUSH',
    {imagePath: folderPath.concat('straightFlush').concat('.png'), alt: 'Straight flush'},
  ],
  ['FULL_HOUSE', {imagePath: folderPath.concat('fullHouse').concat('.png'), alt: 'Full House'}],
  ['ROYAL_FLUSH', {imagePath: folderPath.concat('royalFlush').concat('.png'), alt: 'Royal flush'}],
]);

const ResultImage = React.memo((props: ResultImageProps) => {
  const {classes, t} = useCommon({
    withStyles: styles,
    withTranslation: ['table_area', 'best_combination', 'common'],
  });
  const {combinationName} = props;

  if (!combinationName) {
    return null;
  }

  const attributes = resultImageAttributes.get(combinationName);
  if (!attributes) {
    return null;
  }
  return (
    <div className={classNames(classes.combinationAnimationContainer)}>
      <img src={attributes.imagePath} alt={attributes.alt} className={classes.gameResultIMG} />
    </div>
  );
});

ResultImage.displayName = 'ResultImage';

export default ResultImage;
